import axios from "axios";

export const saveBookingDisambiguationJimpi = async (disambiguationId: string | undefined): Promise<any> => {
    const response = await axios.post(`/booking/import/saveDisambiguationBooking`, null, {params: {disambiguationId}});
    return response.data;
};
